module.exports = __webpack_public_path__ + "img/fundo-solutions.ba57eb93.jpg";